'use strict';

(() => {
  const initSwiper = (slider, options) => {
    if (!slider || typeof window.Swiper === 'undefined') return;
    if (slider.swiper) slider.swiper.destroy(true, true);
    slider.swiper = new window.Swiper(slider, options);
  };

  const initRecipeSliders = () => {
    document.querySelectorAll('[data-recipe-products-slider]').forEach((slider) => {
      const recipeProducts = slider.closest('.recipe-products');

      initSwiper(slider, {
        slidesPerView: 'auto',
        loop: false,
        navigation: {
          nextEl: recipeProducts?.querySelector('.recipe-products__nav--next'),
          prevEl: recipeProducts?.querySelector('.recipe-products__nav--prev'),
        },
        scrollbar: {
          el: slider.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        spaceBetween: 12,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
        },
      });
    });

  };

  const setupAddAllForm = (form) => {
    form.addEventListener('submit', (event) => {
      if (!window.routes?.cart_add_url || typeof window.fetchConfig !== 'function') return;

      event.preventDefault();

      const submitButton = form.querySelector('[type="submit"]');
      const items = Array.from(form.querySelectorAll('input[name$="[id]"]'))
        .map((input) => ({
          id: Number.parseInt(input.value, 10),
          quantity: 1,
        }))
        .filter((item) => item.id);

      if (!items.length) return;

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items };

      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      fetch(window.routes.cart_add_url, {
        ...window.fetchConfig('javascript'),
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return;

          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          }

          if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'recipe-products',
              cartData: response,
            });
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        });
    });
  };

  const setupRecipeInteractions = () => {
    initRecipeSliders();

    document.querySelectorAll('.recipe-products__all-form').forEach(setupAddAllForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupRecipeInteractions);
  } else {
    setupRecipeInteractions();
  }
})();
